import "./Button.css";
import { forwardRef } from "react";

const Button = forwardRef(function Button(props, ref) {
  const variant = props.variant || "primary";

  return (
    <button
      ref={ref}
      type={props.type || "button"}
      className={`btn btn-${variant}${props.block ? " btn-block" : ""}${
        props.small ? " btn-small" : ""
      }${props.className ? ` ${props.className}` : ""}`}
      onClick={props.onClick}
      disabled={props.disabled || props.busy}
      aria-busy={props.busy || undefined}
    >
      {props.busy ? <span className="btn-spinner" aria-hidden="true" /> : props.icon}
      <span className="btn-label">{props.busy ? props.busyLabel || props.children : props.children}</span>
    </button>
  );
});

export default Button;
